<template>
  <div>
    <h2>Login | {{ isLoggedIn }}</h2>
    <v-container>
      
      <v-row justify="center" v-if="!isLoggedIn">
        <v-col cols="auto">
          <v-btn
            color="primary"
            @click="loginWithFacebook"
            class="ma-2"
          >
            <v-icon left>mdi-facebook</v-icon>
            Mit Facebook anmelden
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { onMounted,ref,inject,defineProps } from 'vue';

import { useUserStore } from '@/stores/userStore';
import { useRouter } from 'vue-router';
const router = useRouter();
const isLoggedIn = ref(false);
const loaderStore = inject('loaderStore')
const errorStore = inject('errorStore')
const baseCalls = inject('baseCalls')
const userStore = useUserStore();

const submitStarted = ref(false);
const props = defineProps({
     newRoute: {
       type: [String]
     }
   });
console.log(props.newRoute);

// Deklariere FB als global, um Linter-Fehler zu vermeiden
/* global FB */

onMounted(() => {
  // Facebook SDK initialisieren
  window.fbAsyncInit = function() {
    FB.init({
      appId      : '563907036335909', // Ersetze durch deine Facebook App ID
      cookie     : true,
      xfbml      : true,
      version    : 'v12.0'
    });
  };

  // Facebook SDK laden
  (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
});

async function startLoginFacebook(payload) {
  // Formular validieren
  submitStarted.value = true;

  // Prüfen, ob es Fehler gibt
  let data = {
    user_email: payload.email,
    user_facebook_id: payload.id,
    user_name: payload.name,
    action: 'startLoginFacebook'
  }

  // Wenn keine Fehler vorhanden sind, Login-Logik ausführen
  console.log('Login wird gestartet...')
  // Ladezustand aktivieren
  loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");

  try {
    const response = await baseCalls.userPost(data);
    if (response.data.user ) {
      console.log('Benutzerdaten geladen:', response.data);
      isLoggedIn.value = true;
      userStore.setUser(response.data.user )
      loaderStore.setLoader(false);
      if (props.newRoute) {
          // Timeout von 1 Sekunde vor der Weiterleitung
          router.push(props.newRoute);
      }
    } else {
      errorStore.setError(true, response.data.message);
    }
  } catch (err) {
   
    errorStore.setError(true, 'Es ist ein Fehler aufgetreten');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}

function loginWithFacebook() {
  FB.login(function(response) {
    if (response.authResponse) {
      // Hier wird der Access Token aus der Antwort verwendet, 
      // ohne ihn global zu setzen
      const accessToken = response.authResponse.accessToken;
      
      FB.api('/me', { access_token: accessToken, fields: 'name,email' }, function(userData) {
        if(userData.id){
         
          console.log('Good to see you, ' + userData.name + '.');
          console.log(userData);
          startLoginFacebook(userData);
        }
       
        // Hier kannst du mit dem Benutzer und seinem Token arbeiten
      });
    } else {
      console.log('User cancelled login or did not fully authorize.');
    }
  }, { scope: 'public_profile,email' });
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
